import React from 'react';
import AppLayout from '../components/AppLayout'

export default function Home() {
  return (
    <AppLayout title={""}>
      <div className='content'>Hola :)</div>
    </AppLayout>
  )
}
